import React from 'react';
import { EllipsisVertical } from 'lucide-react';

import { Button } from '@dashboard/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@dashboard/components/ui/dropdown-menu';

/** The three-dot menu in a card heading or a table row. items: [{ label, onSelect, disabled, destructive }]. */
const OrderCardMenu = ({ items, label = 'More options' }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="ghost" size="icon-sm" aria-label={label}>
        <EllipsisVertical className="size-5 text-muted-foreground" aria-hidden="true" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      {items.map(item => (
        <DropdownMenuItem
          key={item.label}
          onSelect={item.onSelect}
          disabled={item.disabled}
          variant={item.destructive ? 'destructive' : 'default'}
        >
          {item.label}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);

export default OrderCardMenu;
